var render = function () {
  var _vm$product2, _vm$product3, _vm$product4, _vm$reviewResponse, _vm$reviewResponse$er;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "root",
    staticClass: "order-review"
  }, [_c('div', {
    staticClass: "order-review__wrapper"
  }, [_vm.loadError ? _c('StatusBlock', {
    attrs: {
      "size": "l",
      "margin": "0",
      "type": "error"
    }
  }, [_c('div', {
    staticClass: "order-review__error-wrapper"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("\n          Попробуйте обновить страницу, или воспользоваться страницей позднее\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "order-review__error-button"
  }, [_c('Button', {
    attrs: {
      "fluid": "",
      "size": "39",
      "theme": "white"
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("\n            Обновить страницу\n          ")])], 1)])]) : [_vm.success ? [_c('div', {
    staticClass: "order-review__thank"
  }, [_c('h2', {
    staticClass: "order-review__thank-title"
  }, [_vm._v("\n            Спасибо!\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "p mb-13"
  }, [_vm._v("\n            Отзыв отправлен на модерацию. "), _c('br'), _vm._v("\n            После подтверждения он будет опубликован 👍🏻\n          ")]), _vm._v(" "), _c('Timer', {
    on: {
      "end": function ($event) {
        _vm.product && (_vm.type === 'edit' ? _vm.router.push('/user/review/') : _vm.router.push(_vm.product.path));
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _vm$product;

        var activate = _ref.activate,
            deactivate = _ref.deactivate,
            time = _ref.time;
        return [_c('nuxt-link', {
          staticClass: "link link_wu link_grey",
          attrs: {
            "to": ((_vm$product = _vm.product) === null || _vm$product === void 0 ? void 0 : _vm$product.path) || '#'
          },
          nativeOn: {
            "mouseover": function ($event) {
              return deactivate.apply(null, arguments);
            },
            "mouseout": function ($event) {
              return activate.apply(null, arguments);
            }
          }
        }, [_vm._v("\n              Вернемся назад через " + _vm._s(time) + "с\n            ")])];
      }
    }], null, false, 3921730554)
  })], 1)] : [_c('h3', {
    staticClass: "order-review__title"
  }, [_vm._v("\n          Отзыв о товаре\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "order-review__desc"
  }, [_vm._v("\n          Поделитесь своим мнением\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "order-review__mini-card"
  }, [_c('nuxt-link', {
    staticClass: "link link_wu",
    attrs: {
      "to": ((_vm$product2 = _vm.product) === null || _vm$product2 === void 0 ? void 0 : _vm$product2.path) || '#'
    }
  }, [_c('MiniCard', {
    attrs: {
      "size": "large",
      "price": _vm.beautifyPrice,
      "name": (_vm$product3 = _vm.product) === null || _vm$product3 === void 0 ? void 0 : _vm$product3.name,
      "image": (_vm$product4 = _vm.product) === null || _vm$product4 === void 0 ? void 0 : _vm$product4.image
    }
  })], 1)], 1), _vm._v(" "), _c('ValidationObserver', {
    ref: "observerRef"
  }, [_c('Form', {
    attrs: {
      "adaptive-on900": "",
      "type": "vertical"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "rules": "required",
      "name": "рейтинг"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var errors = _ref2.errors;
        return [_c('FormElement', {
          attrs: {
            "error": errors[0]
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_c('h5', {
                staticClass: "h5"
              }, [_vm._v("\n                    Оцените вашу покупку\n                  ")])];
            },
            proxy: true
          }], null, true)
        }, [_vm._v(" "), _c('TSProductRating', {
          staticClass: "mt-15",
          attrs: {
            "interactive": "",
            "is-active": _vm.data.rate,
            "size": "32",
            "mobile-size": "25",
            "data-e2e": "review-rating"
          },
          on: {
            "update:model-value": function ($event) {
              _vm.data.rate = $event;
            }
          },
          model: {
            value: _vm.data.rate,
            callback: function ($$v) {
              _vm.$set(_vm.data, "rate", $$v);
            },
            expression: "data.rate"
          }
        })], 1)];
      }
    }])
  }), _vm._v(" "), _c('h5', {
    staticClass: "order-review__subtitle"
  }, [_vm._v("\n              Расскажите подробнее\n            ")]), _vm._v(" "), _c('FormElement', {
    attrs: {
      "hint-min-height": "0",
      "title": "Достоинства:"
    }
  }, [_c('Textarea', {
    attrs: {
      "height": 123,
      "placeholder": "Что вам понравилось",
      "data-e2e": "review-advantage"
    },
    model: {
      value: _vm.data.advantage,
      callback: function ($$v) {
        _vm.$set(_vm.data, "advantage", $$v);
      },
      expression: "data.advantage"
    }
  })], 1), _vm._v(" "), _c('FormElement', {
    attrs: {
      "hint-min-height": "0",
      "title": "Недостатки:"
    }
  }, [_c('Textarea', {
    attrs: {
      "height": 123,
      "placeholder": "Что не понравилось",
      "data-e2e": "review-limitations"
    },
    model: {
      value: _vm.data.limitation,
      callback: function ($$v) {
        _vm.$set(_vm.data, "limitation", $$v);
      },
      expression: "data.limitation"
    }
  })], 1), _vm._v(" "), _c('FormElement', {
    attrs: {
      "hint-min-height": "0",
      "title": "Комментарий:"
    }
  }, [_c('Textarea', {
    attrs: {
      "height": 123,
      "placeholder": "Другие впечатления",
      "data-e2e": "review-comment"
    },
    model: {
      value: _vm.data.text,
      callback: function ($$v) {
        _vm.$set(_vm.data, "text", $$v);
      },
      expression: "data.text"
    }
  })], 1), _vm._v(" "), _vm.type === 'create' ? [_c('div', {
    staticClass: "order-review__photo"
  }, [_c('h5', {
    staticClass: "h5 mt-20"
  }, [_vm._v("\n                  Добавьте фото\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "order-review__photo-desc"
  }, [_vm._v("\n                  Подойдут изображения не более 5 MB\n                ")])]), _vm._v(" "), _c('PhotoUpload', {
    attrs: {
      "multiple": "",
      "data-e2e": "review-images"
    },
    on: {
      "error": function ($event) {
        _vm.errorImageInput = $event.message;
      },
      "update": function ($event) {
        _vm.data.image = $event, _vm.errorImageInput = undefined;
      }
    },
    model: {
      value: _vm.data.image,
      callback: function ($$v) {
        _vm.$set(_vm.data, "image", $$v);
      },
      expression: "data.image"
    }
  })] : _vm._e(), _vm._v(" "), _vm.error || _vm.errorImageInput ? _c('Note', {
    staticClass: "my-10",
    attrs: {
      "theme": "reddish"
    }
  }, [_vm._v("\n              " + _vm._s(((_vm$reviewResponse = _vm.reviewResponse) === null || _vm$reviewResponse === void 0 ? void 0 : (_vm$reviewResponse$er = _vm$reviewResponse.error) === null || _vm$reviewResponse$er === void 0 ? void 0 : _vm$reviewResponse$er.description) || _vm.errorImageInput || 'Что-то пошло не так') + "\n            ")]) : _vm._e(), _vm._v(" "), _vm.success ? _c('Button', {
    staticClass: "order-review__button",
    attrs: {
      "theme": "submited",
      "size": "49",
      "disabled": ""
    }
  }, [_vm._v("\n              Отзыв отправлен на модерацию\n            ")]) : _vm.loading ? _c('Button', {
    staticClass: "order-review__button",
    attrs: {
      "size": "49",
      "theme": "red",
      "loading": ""
    }
  }) : _c('Button', {
    staticClass: "order-review__button",
    attrs: {
      "size": "49",
      "data-e2e": "review-submit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n              Отправить отзыв\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "order-review__privacy-policy"
  }, [_vm._v("\n              Нажимая кнопку «Отправить отзыв», я подтверждаю согласие с\n              "), _c('nuxt-link', {
    staticClass: "link link_blue link_blue",
    attrs: {
      "to": "/about/terms-of-use/"
    }
  }, [_vm._v("\n                условиями политики обработки персональных данных.\n              ")])], 1)], 2)], 1)]]], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }